<template>
    <router-view></router-view>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";

    @Component
    export default class Voting extends Vue {
    }
</script>

<style scoped>
</style>
